import React, { useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./featured.module.css"; // Import the CSS module

const Featured = ({ data }) => {
  const totalSlides = 6; // Total number of slides
  const [currentSlide, setCurrentSlide] = useState(0);

  const handleBeforeChange = (current, next) => {
    setCurrentSlide(next); // Update the current slide index
  };
  const sliderSettings = {
    slidesToShow: 4, // Default: show one slide at a time
    slidesToScroll: 1,
    rows: 2,
    slidesPerRow: 2,
    speed: 400,
    beforeChange: handleBeforeChange,
    responsive: [
      {
        breakpoint: 768, // For screens smaller than 768px (tablets)
        settings: {
          slidesToShow: 3, // Still shows one slide
          speed: 300, // Optional: Adjust speed for smaller screens
        },
      },
      {
        breakpoint: 480, // For screens smaller than 480px (mobile)
        settings: {
          slidesToShow: 2, // Still shows one slide
          speed: 200, // Optional: Further adjust speed
        },
      },
    ],
  };

  const slider2Ref = useRef(null);

  const handlePrevClick = () => {
    if (slider2Ref.current) slider2Ref.current.slickPrev();
  };

  const handleNextClick = () => {
    if (slider2Ref.current) slider2Ref.current.slickNext();
  };

  return (

    <div className={styles.content}>
      <h3 className={styles.heading}>Featured Brands
      </h3>
      <div className={styles.section}>
        {
          data?.length > 0 &&
          <Slider ref={slider2Ref} {...sliderSettings} className={styles.slider}>

            {
              data.map((thumbnail, i) => (

                <div className={styles.slidecontant}>

                  <div className={styles.image}>
                    <img src={thumbnail?.thumbnail?.photo[0]} alt="Bose Logo" className={styles.image} />
                  </div>
                </div>
              ))
            }
          </Slider>
        }

        {/* Dots for Slide Progress */}
        <div className={styles.footersec}>
          <div className={styles.dotsContainer}>
            {Array.from({ length: Math.ceil(data?.length / 2) }).map((_, index) => (
              <div
                key={index}
                className={`${styles.dot} ${index === currentSlide ? styles.active : ""}`}
              ></div>
            ))}
          </div>
          {/* Navigation Arrows */}
          <div className={styles.sliderArrows}>
            <div className={styles.prevArrow} onClick={handlePrevClick}>
              <svg
                width="100%"
                height="100%"
                viewBox="0 0 40 41"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.5"
                  y="1"
                  width="39"
                  height="39"
                  rx="19.5"
                  stroke="#B3B3B3"
                />
                <path
                  d="M23 14.5L17 20.5L23 26.5"
                  stroke="#656567"
                  strokeWidth="2"
                />
              </svg>
            </div>
            <div className={styles.nextArrow} onClick={handleNextClick}>
              <svg
                width="100%"
                height="100%"
                viewBox="0 0 40 41"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect y="0.5" width="40" height="40" rx="20" fill="#512DA8" />
                <path
                  d="M17 14.5L23 20.5L17 26.5"
                  stroke="white"
                  strokeWidth="2"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Featured;
